import { STATUS_STEP_CONFIG } from '@shared/components/constants/select.constant';
import { STEP_STATUS, StepStatus } from '@shared/types/enums';
import classNames from 'classnames';
import { Check } from 'lucide-react';

interface StepItemProps {
    stepStatus: StepStatus,
    content?: string,
    className?: string,
    isFirst?: boolean,
    isLast?: boolean,
    zIndex?: number
}

function buildClipPath(isFirst: boolean, isLast: boolean, aw: string): string {
    if (isFirst && isLast) {
        return 'none';
    }
    if (isFirst) {
        return `polygon(0 0, calc(100% - ${aw}) 0, 100% 50%, calc(100% - ${aw}) 100%, 0 100%)`;
    }
    if (isLast) {
        return `polygon(0 0, 100% 0, 100% 100%, 0 100%, ${aw} 50%)`;
    }
    return `polygon(0 0, calc(100% - ${aw}) 0, 100% 50%, calc(100% - ${aw}) 100%, 0 100%, ${aw} 50%)`;
}

export default function StepItem(props: StepItemProps) {
    const { content, stepStatus, className, isFirst = false, isLast = false, zIndex = 0 } = props;

    const cfg = STATUS_STEP_CONFIG[stepStatus];

    const clipBase = buildClipPath(isFirst, isLast, 'var(--step-arrow, 16px)');

    return (
        <div
            className={classNames(
                'step-item relative flex-1 h-full min-w-0',
                className
            )}
            style={{
                marginLeft: isFirst ? undefined : 'calc(-1 * (var(--step-arrow, 16px) - 2px))',
                zIndex
            }}
        >
            <div
                className={classNames('absolute inset-0', cfg.bgColor)}
                style={{
                    clipPath: clipBase
                }}
            />

            <div
                className={classNames(
                    'relative z-10 flex items-center justify-center h-full font-bold text-[10px] sm:text-sm py-2 sm:py-4',
                    isFirst ? 'pl-2 sm:pl-10' : 'pl-5 sm:pl-14',
                    isLast ? 'pr-2 sm:pr-10' : 'pr-5 sm:pr-14',
                    cfg.textColor
                )}
            >
                <div className='flex justify-center items-center gap-1.5 md:gap-2 w-full text-center text-cs-label font-bold'>
                    {
                        stepStatus === STEP_STATUS.PASS && (
                            <div className='shrink-0 border-2 border-white relative flex size-4 justify-center items-center rounded-full ml-3'>
                                <div className='absolute z-10 inset-0 rounded-full bg-white opacity-20'></div>
                                <Check className='relative z-20 size-2.5 md:size-3' strokeWidth={1.5} color='white' absoluteStrokeWidth />
                            </div>
                        )
                    }
                    <div className='whitespace-nowrap text-xs sm:text-sm'>{content}</div>
                </div>
            </div>
        </div>
    );
}
